import { msalInstance } from "../index";
import { loginRequest } from "../authConfig";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { startIdTokenWacht } from "./idTokenVooraf";

let refreshInterval = null;
let stopIdTokenWacht = null;
let isRefreshing = false; // Voorkom overlappende refresh pogingen

// Start periodieke token refresh
export const startTokenRefresh = () => {
    // Stop eventuele bestaande interval
    stopTokenRefresh();
    // ID-token vooraf verversen (zie idTokenVooraf.js): anders wacht de eerste
    // API-aanvraag van een pagina op de token-server.
    stopIdTokenWacht = startIdTokenWacht();
    
    // Functie om token te vernieuwen
    const refreshToken = async () => {
        // Voorkom overlappende refresh pogingen
        if (isRefreshing) {
            console.log("[Token Refresh] Refresh al bezig, skip deze poging");
            return false;
        }
        
        const account = msalInstance.getActiveAccount();
        if (account) {
            isRefreshing = true;
            try {
                console.log("[Token Refresh] Poging om token te vernieuwen...");
                await msalInstance.acquireTokenSilent({
                    ...loginRequest,
                    account: account
                });
                console.log("[Token Refresh] Token succesvol vernieuwd");
                return true;
            } catch (error) {
                // Check of het een timeout error is
                if (error.errorCode === "monitor_window_timeout") {
                    console.warn("[Token Refresh] Timeout bij vernieuwen - dit is normaal in sommige browsers");
                } else if (error instanceof InteractionRequiredAuthError || error.errorCode === "interaction_required") {
                    // Achtergrond blijft stil: geen redirect of popup zonder dat de gebruiker iets
                    // doet (dat haalde je midden in je werk van de pagina). De eerstvolgende
                    // API-aanvraag (authHelpers) vraagt zo nodig om opnieuw inloggen.
                    console.warn("[Token Refresh] Sessie verlopen; opnieuw inloggen volgt bij de volgende aanvraag");
                } else if (error.errorCode === "interaction_in_progress") {
                    console.warn("[Token Refresh] Interaction al bezig, skip deze poging");
                } else {
                    console.warn("[Token Refresh] Token refresh mislukt:", error.errorCode || error.message);
                }
                return false;
            } finally {
                isRefreshing = false;
            }
        }
        return false;
    };
    
    // Wacht 5 seconden voordat we de eerste keer refreshen (geef app tijd om te laden)
    setTimeout(async () => {
        await refreshToken();
        
        // Start interval alleen als we een actief account hebben
        if (msalInstance.getActiveAccount()) {
            // Elke 50 minuten (veiliger dan 45, tokens zijn meestal 60 min geldig)
            refreshInterval = setInterval(refreshToken, 50 * 60 * 1000);
            console.log("[Token Refresh] Periodieke refresh gestart (elke 50 minuten)");
        }
    }, 5000);
};

// Stop periodieke token refresh
export const stopTokenRefresh = () => {
    if (stopIdTokenWacht) { stopIdTokenWacht(); stopIdTokenWacht = null; }
    if (refreshInterval) {
        clearInterval(refreshInterval);
        refreshInterval = null;
        console.log("[Token Refresh] Periodieke refresh gestopt");
    }
    isRefreshing = false; // Reset refresh status
}; 